import React from "react";

import Heading from "@common/components/Heading/Heading";
import { PlatformName } from "@common/models";
import { CrashType } from "@common/models/crashReporting";
import { vars } from "@common/styles";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import { TicketListFilters } from "@main/pages/Release/helpers/ticketListLink";
import { ReleaseMetricCard, ReleaseMetricCardBaseProps } from "@main/pages/Release/views/MetricCards/ReleaseMetricCard";
import { OpenExternalButton } from "@main/pages/Release/views/MetricCards/shared/OpenExternalButton";

interface AppHangFreeSessionsProps extends ReleaseMetricCardBaseProps {
  platform: PlatformName;
  rate: number;
  totalAppHangs: number;
  onOpenAppHangsClick: (filters: TicketListFilters) => void;
}

const AppHangFreeSessionsCard = ({
  style,
  rate,
  score,
  highlight,
  error,
  onMoreClick,
  platform,
  totalAppHangs,
  onOpenAppHangsClick,
}: AppHangFreeSessionsProps) => {
  return (
    <ReleaseMetricCard
      style={style}
      title={platform === PlatformName.IOS ? "App hang-free sessions" : "ANR-free sessions"}
      score={score}
      highlight={highlight}
      error={error}
      onMoreClick={onMoreClick}
    >
      <Flex $column>
        <Flex style={{ alignItems: "center" }}>
          <Heading
            heading2
            style={{ marginRight: "1.8rem" }}
            marginBottom={0}
          >{`${rate.toString()}%`}</Heading>
          <Heading
            heading3
            style={{ color: vars.colors.grey60 }}
            marginBottom={0}
          >{`${totalAppHangs.toString()} app hangs`}</Heading>
          <OpenExternalButton
            style={{ marginLeft: "0.4rem" }}
            onClick={() => onOpenAppHangsClick({ reportType: CrashType.ANR })}
          />
        </Flex>
      </Flex>
    </ReleaseMetricCard>
  );
};

export { AppHangFreeSessionsCard };
